import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getBuyerForecastSaveDataSlice = createApi(`BuyerForecastSaveDataSlice`,"POST");

const BuyerForecastSaveDataSlice = createSlice({
  name: 'BuyerForecastSaveDataSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBuyerForecastSaveDataSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getBuyerForecastSaveDataSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getBuyerForecastSaveDataSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default BuyerForecastSaveDataSlice.reducer;